import { ProductSpecCode } from '../types/productSchema';

export const ProductSpecsTyresModal = [
  ProductSpecCode.Width,
  ProductSpecCode.Height,
  ProductSpecCode.Diameter,
  ProductSpecCode.Season,
  ProductSpecCode.Spikes,
  ProductSpecCode.LoadIndex,
  ProductSpecCode.SpeedIndex,
  ProductSpecCode.RunFlat,
  ProductSpecCode.TruckTyresWidth,
  ProductSpecCode.TruckTyresHeight,
  ProductSpecCode.TruckTyresDiam,
];

export const ProductSpecsDisksModal = [
  ProductSpecCode.DiskWidth,
  ProductSpecCode.DiskRadius,
  ProductSpecCode.DiskUnitedPcd,
  ProductSpecCode.DiskEt,
  ProductSpecCode.DiskDia,
  ProductSpecCode.DiskType,
];

export const ProductSpecsAkbModal = [
  ProductSpecCode.AkbWidth,
  ProductSpecCode.AkbHeight,
  ProductSpecCode.AkbLength,
  ProductSpecCode.AkbCapacity,
  ProductSpecCode.AkbPolarity,
];
